import React from "react";
import LandingPageAppBar from "../components/LandingPageAppBar";
import {Link, NavLink} from 'react-router-dom'
import ErrorImage from '../assets/images/404-error.svg';
import Helmet from 'react-helmet';

import Footer from "../components/common/Footer";

const NotFoundPage = () => {
  return (
    <div className="container">
      <Helmet title="Page not found"/>
      <LandingPageAppBar />
      <div className="container-column container-full">
        <div className="container-row container-100">
          <div className="body-container">
            <img className="notfound" alt="page_not_found_image" src={ErrorImage}/>
            <NavLink to="/" className="nav-text">
              <strong>Go back</strong>
            </NavLink>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
};

const mapStateToProps = (state) => {
  return { courseState: state.courses.allCourses };
};


export default NotFoundPage;
